import {
  DuctedCompareCardLookup,
  DuctedComparedSystem,
  findComparedSystemForCard
} from './ducted-compare-identity';

export const compareStateForCard = (
  comparedIdByCardId: ReadonlyMap<string, string>,
  systemsToCompare: ReadonlyArray<DuctedComparedSystem>,
  lookup: DuctedCompareCardLookup
): { comparedId: string | undefined; added: boolean } => {
  const mappedId = comparedIdByCardId.get(lookup.cardId);
  if (
    mappedId !== undefined &&
    systemsToCompare.some((system) => system.id === mappedId)
  ) {
    return { comparedId: mappedId, added: true };
  }
  const rematched = findComparedSystemForCard(systemsToCompare, lookup);
  return {
    comparedId: rematched?.id,
    added: rematched != null
  };
};

export const comparedIdForSelection = (
  comparedIdByCardId: ReadonlyMap<string, string>,
  systemsToCompare: ReadonlyArray<DuctedComparedSystem>,
  selection: DuctedCompareCardLookup | null | undefined
): string | undefined => {
  if (!selection) return undefined;
  return compareStateForCard(comparedIdByCardId, systemsToCompare, selection)
    .comparedId;
};

export const withMappedComparedId = (
  previous: ReadonlyMap<string, string>,
  cardId: string,
  systemId: string
): ReadonlyMap<string, string> => new Map(previous).set(cardId, systemId);
